<template>
  <div class="form-control w-full mb-4">
    <label class="label" v-if="label" :for="fieldId">
      <span class="label-text font-medium">{{ label }}</span>
    </label>
    <slot></slot>
    <label class="label" v-if="message">
      <span class="label-text-alt text-base-content/70">{{ message }}</span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'DField',
  props: {
    label: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      fieldId: this.generateUniqueId()
    }
  },
  mounted() {
    this.associateFormElements();
  },
  methods: {
    generateUniqueId() {
      return `field-${Math.random().toString(36).substr(2, 9)}`;
    },
    associateFormElements() {
      // Find all form input elements within this field component
      const formElements = this.$el.querySelectorAll('input, select, textarea');
      
      if (formElements.length > 0) {
        // Associate the first form element with the label
        const firstElement = formElements[0];
        if (!firstElement.id) {
          firstElement.id = this.fieldId;
        }
      }
    }
  }
}
</script>